import { render, staticRenderFns } from "./prediction.vue?vue&type=template&id=605ce6f6&"
import script from "./prediction.vue?vue&type=script&lang=js&"
export * from "./prediction.vue?vue&type=script&lang=js&"
import style0 from "spinkit/spinkit.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./prediction.vue?vue&type=style&index=1&id=605ce6f6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports